module.exports = __webpack_public_path__ + "static/media/mx.d44ce0bf.svg";